export const stepOneData = [
  {
    heading: "Why Use Minemi’s EMI Calculator for Credit Cards?",

    infoList: [
      {
        heading: "Accurate EMI Estimates: ",
        description:
          "Calculate your monthly payments for different transactions and tenures.",
      },
      {
        heading: "Compare Interest Rates Across Cards: ",
        description:
          "Understand which credit card offers the lowest EMI conversion rates.",
      },
      {
        heading: "Educative Insights: ",
        description:
          "Learn how interest rates, processing fees, and tenures affect your total repayment.",
      },
      {
        heading: "Balance Transfer Scenarios: ",
        description:
          "Evaluate savings by transferring your credit card balance to another card or loan with a lower interest rate.",
      },
      {
        heading: "Prepayment Options: ",
        description:
          "See how paying off your credit card EMIs early can reduce your interest burden.",
      },
    ],

    tablecontent: {
      heading: [
        {
          head: "Tenure",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Total Interest (₹)",
        },
        {
          head: "Total Repayment (₹)",
        },
      ],
      row: [
        {
          tenure: "3 years",
          emi: "16,607",
          interest: "99,852",
          repayment: "5,99,852",
        },
        {
          tenure: "5 years",
          emi: "11,122",
          interest: "1,67,320",
          repayment: "6,67,320",
        },
      ],
    },
  },
];

export const stepTwoData = [
  {
    heading: "What You Can Do With the Credit Card EMI Calculator",
    subtitle:
      "The Annual Percentage Rate (APR) provides a comprehensive view of the loan’s cost by including both the interest rate and additional fees like processing charges. This helps in comparing different loan offers more effectively.",

    tip: " A loan with a slightly higher interest rate but lower processing fees might have a lower APR, making it more cost-effective in the long run.",

    paraOne:
      "Don’t see what you’re looking for? NerdWallet has a long list of mortgage calculators to help you make whatever financial decision comes your way.",

    creditCardList: [
      {
        heading: "Calculate EMI on Large Purchases: ",
        info: "Enter the transaction amount, interest rate, and tenure to estimate your monthly payment.",
      },
      {
        heading: "Compare EMI Conversion Offers: ",
        info: "Check EMI interest rates offered by different credit cards to choose the most affordable option.",
      },
      {
        heading: "Plan Balance Transfers: ",
        info: "Use the calculator to explore savings when transferring your outstanding balance to a lower-interest option, such as another credit card or a personal loan.",
      },
    ],

    tipHead: "Understand EMI Conversion Fees",
    tipList: [
      {
        list: "Most credit cards charge a one-time processing fee (1%-3%) for EMI conversions.",
      },
      {
        list: "Use the calculator to factor in these fees and get a complete picture of your total repayment amount.",
      },
      {
        list: "Avoid overspending by evaluating the long-term impact of EMI conversions on your finances.",
      },
    ],
  },
];

export const stepThreeData = [
  {
    heading: "Sample EMI Calculation for Credit Cards",

    calculationTable: {
      heading: [
        {
          head: "Transaction Amount",
        },

        {
          head: "Interest Rate (%)",
        },
        {
          head: "Tenure (Months)",
        },
        {
          head: "EMI (₹)",
        },
        {
          head: "Processing Fee (₹)",
        },
        {
          head: "Total Payment (₹)",
        },
      ],
      row: [
        {
          amount: "₹50,000",
          interest: "18%",
          tenure: "12",
          emi: "₹4,583",
          processingFee: "₹1,000",
          totalPayment: "₹55,996",
        },
        {
          amount: "₹75,000",
          interest: "16%",
          tenure: "18",
          emi: "₹4,998",
          processingFee: "₹1,500",
          totalPayment: "₹90,984",
        },
        {
          amount: "₹1,00,000",
          interest: "20%",
          tenure: "24",
          emi: "₹5,482",
          processingFee: "₹2,000",
          totalPayment: "₹1,33,568",
        },
      ],
    },
    note: "Figures are indicative and vary based on the credit card issuer’s terms. Use Minemi’s calculator for customized results.",

    tipHead: "Balance Transfer for High-Interest Cards",
    tipList: [
      {
        list: "If your credit card interest rate is high (e.g., 24%-36%), consider transferring the balance to a lower-interest card or loan.",
      },
      {
        list: "Balance transfers can help reduce your monthly payments and total repayment amount significantly.",
      },
      {
        list: "Minemi helps you compare balance transfer offers from multiple banks.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "Use Cases for Credit Card EMI Conversions",
    subtitle:
      "The interest rate directly impacts your EMI and the total cost of the loan. A lower interest rate reduces both your monthly payments and the overall amount payable.",

    negotiatingHead: "Negotiating Interest Rates:",
    list: [
      {
        head: "Splitting Large Purchases into EMIs",
        info: "Bought a high-value item like a smartphone or home appliance? Converting the transaction into EMIs helps you manage the cost without affecting your savings. Use the EMI calculator to estimate your monthly payments.",
      },
      {
        head: "Emergency Medical Expenses",
        info: "Unexpected medical bills can strain your budget. Credit card EMIs allow you to spread the cost over manageable installments, ensuring financial stability during emergencies.",
      },
      {
        head: "Consolidating Multiple Credit Card Payments",
        info: "If you’re juggling payments on multiple credit cards, consider consolidating the outstanding balance into one card or loan with a lower interest rate. Minemi helps you evaluate the best consolidation options.",
      },
      {
        head: "Traveling with Flexibility",
        info: "Plan a vacation without worrying about upfront costs. Use EMI options on your credit card to pay for flights, hotels, and more over time.",
      },
    ],
    tipHead: "Know the True Cost of Credit Card EMIs",
    tipList: [
      {
        list: "Interest rates on credit card EMIs can be higher (12%-24%) compared to personal loans.",
      },
      {
        list: "Always check if a personal loan or balance transfer offers better repayment terms for your financial situation.",
      },
      {
        list: "Use Minemi’s tools to compare all options and choose wisely.",
      },
    ],
  },
];
